/**
 * 头部导航
 */
export default {
  signIn: '登入',
  signOut: '登出',
}
